import React,{Component, useEffect, useState } from "react";
import styled from "styled-components";
import SidebarItems from "../SidebarItems";
import { Link } from "react-router-dom";

function Sidebar(props, { defaultActive }) {
  const location = props.history.location;
  const lastActiveIndexString = localStorage.getItem("lastActiveIndex");
  const lastActiveIndex = Number(lastActiveIndexString);
  const [activeIndex, setActiveIndex] = useState(
    lastActiveIndex || defaultActive
  );

  function changeActiveIndex(newIndex) {
    localStorage.setItem("lastActiveIndex", newIndex);
    setActiveIndex(newIndex);
  }

  function getPath(path) {
    if (path.charAt(0) !== "/") {
      return "/" + path;
    }
    return path;
  }

  useEffect(() => {
    const activeItem = SidebarItems.findIndex(
      (item) => getPath(item.route) === getPath(location.pathname)
    );
    changeActiveIndex(activeItem);
  }, [location]);

  return (
    <>
      <SidebarParent>
        <div style={{ position: "fixed" }}>
          {SidebarItems.map((item, index) => {
            return (
              <Link to={item.route} key={index}>
                <SidebarItem key={item.name} active={index === activeIndex}>
                  <div className="sidebar_items">
                    <i className="sidebar_icon"> {item.icon}</i>
                    {item.name}
                  </div>
                </SidebarItem>
              </Link>
            );
          })}
        </div>
        <div className="behind-the-scenes" />
      </SidebarParent>
    </>
  );
}

export default Sidebar;

const SidebarParent = styled.div`
  background: #04087c;
 

  a {
    text-decoration: none;
  }

  & > div {
    width: 250px;
    height: 100vh;
    flex: 2;
  }

  .behind-the-scenes {
    width: 250px;
   

  }
  .sidebar_items {
    display: flex;
    color: #fff;
    align-items: center;
  }
  .sidebar_icon {
    font-size: 18px;
    margin-right: 6px;
  }
`;

const SidebarItem = styled.div`
  padding: 16px 24px;
  transition: all 0.25s ease-in-out;
  background: ${(props) => (props.active ? "orangered" : "")};
  margin: 4px 12px;
  border-radius: 4px;

  &:hover {
    cursor: pointer;
  }

  &:hover:not(:first-child) {
    background: #c34a36;
  }
`;
